import { useEffect, useLayoutEffect, useRef } from "react";
import * as utils from "shell/app//app.utils";
import "./hero.scss";
import isMobile from "ismobilejs";
import parse from "html-react-parser";

interface heroProps {
  title: string[];
  copy: string[];
}

const Hero: React.FC<heroProps> = (props) => {
  const mouse = useRef({ x: 0, y: 0 });
  const aFrame = useRef<any>(0);
  const aPosition = useRef({ x: 0, y: 0 });
  const heroFront = useRef<HTMLImageElement>(null);
  const heroBack = useRef<HTMLImageElement>(null);
  const elRef = useRef<HTMLDivElement>(null);

  // hero parallax movemento
  useLayoutEffect(() => {
    const render = () => {
      if (!document.body.classList.contains("is-scrolled")) {
        aPosition.current.x = utils.lerp(
          aPosition.current.x,
          mouse.current.x,
          0.1
        );
        aPosition.current.y = utils.lerp(
          aPosition.current.y,
          mouse.current.y,
          0.1
        );

        if (heroFront.current && heroBack.current) {
          const metricFront = heroFront.current.clientWidth * 0.01;
          const metricBack = heroFront.current.clientWidth * 0.025;

          const valXFront = (metricFront / 100) * aPosition.current.x;
          const valYFront = (metricFront / 100) * aPosition.current.y;

          const valXBack = (metricBack / 100) * aPosition.current.x;
          const valYBack = (metricBack / 100) * aPosition.current.y;

          heroFront.current.style.transform = `translate(${valXFront}px, ${valYFront}px)`;
          heroBack.current.style.transform = `translate(${-valXBack}px, ${-valYBack}px)`;
        }
      }
      aFrame.current = requestAnimationFrame(render);
    };
    !isMobile().any && (aFrame.current = requestAnimationFrame(render));
    return () => cancelAnimationFrame(aFrame.current);
  }, [mouse]);

  // mouse move for parallax
  useEffect(() => {
    const handleMouseMove = (e: any) => {
      if (!document.body.classList.contains("is-scrolled")) {
        mouse.current = {
          x:
            (100 / (window.innerWidth / 2)) *
            (e.clientX - window.innerWidth / 2),
          y:
            (100 / (window.innerHeight / 2)) *
            (e.clientY - window.innerHeight / 2),
        };
      }
    };
    !isMobile().any && document.addEventListener("mousemove", handleMouseMove);
    return () => document.removeEventListener("mousemove", handleMouseMove);
  }, []);

  useLayoutEffect(() => {}, []);

  return (
    <div className="hero" ref={elRef}>
      {/* IMAGE */}
      <div className="hero-image wrapper">
        <div className="hero-image__inner">
          <img
            className="hero-image__image is-front"
            src={utils.assetPath("/images/hero-front.png")}
            ref={heroFront}
            alt=""
          />
          <img
            className="hero-image__image is-back"
            src={utils.assetPath("/images/hero-back.png")}
            ref={heroBack}
            alt=""
          />
        </div>
      </div>
      {/* MINUS SPACER */}
      <div className="hero-minus-spacer wrapper">
        <div className="hero-minus-spacer__inner" />
      </div>
      {/* INTRO */}
      <div className="hero-content">
        <div className="hero-intro">
          <div className="wrapper--small">
            <h2>
              {props.title.map((item, key) => (
                <span key={key}>{item}</span>
              ))}
            </h2>
            <p>
              {props.copy.map((item, key) => (
                <span key={key}>{parse(item)}</span>
              ))}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
